@if (helpAndContactData.showButtons && !this.contactData.enableHelpAndContactPhase2) {
    <div class="portal-wrapper-fw" id="contact-options">
        @if (contactData.isVipUser) {
            <div class="bannerMsg">
                <div class="headerBanner" [innerHTML]="contactData.clientContentData.messages.HeaderTitle"></div>
                <p [innerHTML]="contactOptionsData.messages.VipBannerText"></p>
            </div>
        }
        @if (!contactData.isVipUser) {
            <div class="bannerMsg">
                <div class="headerBanner" [innerHTML]="contactData.clientContentData.messages.HeaderTitle"></div>
                <p [innerHTML]="contactOptionsData.messages.NonVipBannerText"></p>
            </div>
        }
        <div>
            <div class="portal-center-wrapper" [ngClass]="{ 'content-width': noOfContactOptions > 4 }">
                @if (!isNullOrUndefined(csMsg)) {
                    <div class="message-panel ng-star-inserted csMessagePanel">
                        <div class="csMsg ng-star-inserted">
                            <div class="cms-container">
                                <span [innerHTML]="csMsg"></span>
                            </div>
                            <span class="csLink" [innerHTML]="csLink" (click)="goToCsLink()"></span>
                        </div>
                    </div>
                }
                <div class="row justify-content-center cards-row" [ngClass]="{ 'cards-row-twitter': noOfContactOptions > 4 }">
                    @if (enabledContactOptions !== null && enabledContactOptions.length > 0) {
                        @for (contactOption of enabledContactOptions; track i; let i = $index) {
                            <div
                                class="card--clickable card card-bg bonus-card card-active-shadow col-sm option-card"
                                [ngClass]="isGtXsDevice ? 'limit-width' : ''">
                                @if (contactOption.key != 'CHAT') {
                                    <div
                                        class="card-body cursorPointer"
                                        [ngClass]="{ 'mt-3': recommenededOptions.length > 0 && recommenededOptions.indexOf(contactOption.key) > -1 }"
                                        (click)="goTo(contactOption.key, i)">
                                        @if (recommenededOptions.length > 0 && recommenededOptions.indexOf(contactOption.key) > -1) {
                                            <ng-container *ngTemplateOutlet="showRecommenededBadge"></ng-container>
                                        }
                                        <div
                                            class="{{ contactOption.value.messages.class }} option-icon"
                                            [ngClass]="isXsDevice ? 'portrait' : '  '"></div>
                                        <div
                                            class="bonus-card-heading-2 option-font"
                                            [ngClass]="{ 'align-text-in-mobile': phase3, 'align-left': isXsDevice }">
                                            {{ contactOption.value.title }}
                                        </div>
                                        <div
                                            class="text-muted-secondary suboption-font bonus-card-heading-1-small"
                                            [innerHTML]="contactOption.value.text | trustAsHtml"
                                            [ngClass]="isXsDevice ? 'align-left' : '  '"></div>
                                    </div>
                                }
                                @if (contactOption.key == 'CHAT') {
                                    <div class="card-body cursorPointer" id="chat" (click)="goTo(contactOption.key, i)">
                                        <div
                                            class="{{ contactOption.value.messages.class }} option-icon"
                                            [ngClass]="isXsDevice ? 'portrait' : '  '"></div>
                                        <div class="inline" [ngClass]="{ 'align-text-in-mobile': phase3 }">
                                            @if (zendeskChatEnabled) {
                                                <div class="form-element">
                                                    <div class="btn-message-container">
                                                        <pt-pull-chat-button
                                                            [isContact]="true"
                                                            [liveChatText]="contactOption.value.title"
                                                            (click)="liveChatClicked()"></pt-pull-chat-button>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                        <div
                                            class="text-muted-secondary suboption-font bonus-card-heading-1-small"
                                            [innerHTML]="contactOption.value.text | trustAsHtml"
                                            [ngClass]="isXsDevice ? 'align-left' : '  '"></div>
                                    </div>
                                }
                            </div>
                        }
                    }
                    @if (disabledContactOptions !== null && disabledContactOptions.length > 0) {
                        @for (contactOption of disabledContactOptions; track $index) {
                            <div
                                class="card--clickable card card-bg bonus-card card-active-shadow option-card disabledContactOptions col-sm"
                                [ngClass]="isGtXsDevice ? 'limit-width' : ''">
                                <div class="disabled" [ngClass]="{ 'card-body': phase2 && !phase3, 'd-flex': phase3 }">
                                    <div
                                        class="{{ contactOption.value.messages.class }} option-icon"
                                        [ngClass]="isXsDevice ? 'portrait' : '  '"></div>
                                    <div
                                        class="bonus-card-heading-2 option-font"
                                        [ngClass]="{ 'align-text-in-mobile': phase3, 'align-left': isXsDevice }">
                                        <div [ngClass]="{ heading: phase3 }">{{ contactOption.value.title }}</div>
                                        @if (phase3) {
                                            <div
                                                class="text-muted-secondary suboption-font bonus-card-heading-1-small contact-touch-pad-0"
                                                [innerHTML]="contactOption.value.text | trustAsHtml"
                                                [ngClass]="isXsDevice ? 'align-left' : '  '"></div>
                                        }
                                    </div>
                                    @if (phase2 && !phase3) {
                                        <div
                                            class="text-muted-secondary suboption-font bonus-card-heading-1-small"
                                            [innerHTML]="contactOption.value.text | trustAsHtml"
                                            [ngClass]="isXsDevice ? 'align-left' : '  '"></div>
                                    }
                                </div>
                            </div>
                        }
                    }
                </div>
                @if (
                    (contactData.showDocumentUploadOption && !contactData.isLoadingIndicatorEnabled && !isCPCCUser) ||
                    (contactData.showDocumentUploadOption &&
                        contactData.isLoadingIndicatorEnabled &&
                        contactData.enableHelpAndContactPhase3 &&
                        loadingIndicationDisabled &&
                        !isCPCCUser)
                ) {
                    <div class="border-top" id="docUploadTxt">
                        <span class="theme-upload ic-upload"></span>
                        <a class="a-cur-pr" (click)="goToDocumentUpload()">{{ uploadDocumentContent }}</a>
                        <i class="ui-icon theme-info-i" [floatUi]="popper.content"></i>
                        <vn-popper-content #popper cssClass="tooltip-info"
                            ><ng-container content>{{ uploadDocumentTooltip }}</ng-container></vn-popper-content
                        >
                    </div>
                }
                @if (
                    (contactData.showContactAddress && !contactData.isLoadingIndicatorEnabled) ||
                    (contactData.showContactAddress &&
                        contactData.isLoadingIndicatorEnabled &&
                        contactData.enableHelpAndContactPhase3 &&
                        loadingIndicationDisabled)
                ) {
                    <div class="d-flex flex-column p-3 border-top" [innerHtml]="contactData.contactInfoText | trustAsHtml"></div>
                }
            </div>
        </div>
    </div>
}
@if (this.contactData.enableHelpAndContactPhase2 && helpAndContactData.showButtons) {
    <div class="portal-wrapper-fw" id="contact-options">
        @if (!this.contactData.helpAndContactUxCleanUpEnabled && !phase3) {
            <div>
                <div class="bannerMsg">
                    <div class="headerBanner" [innerHTML]="contactData.clientContentData.messages.HeaderTitle"></div>
                    <p [innerHTML]="contactOptionsData.messages.NonVipBannerText"></p>
                </div>
            </div>
        }
        @if (this.contactData.helpAndContactUxCleanUpEnabled && !phase3) {
            <div>
                @if (v2NavEnabledPreLogin) {
                    <div class="helpcontact-header padding-content">
                        <span class="theme-contact helpcontact-icon"></span>
                        <div class="helpcontact-iconheader">
                            <div class="helpcontact-mainheader" [innerHTML]="contactData.helpContactContent.title"></div>
                            <div class="helpcontact-subheader" [innerHTML]="contactData.helpContactContent.messages.HelpContactSubHeading"></div>
                        </div>
                    </div>
                }
            </div>
        }
        <div>
            @if (!this.contactData.helpAndContactUxCleanUpEnabled) {
                <div class="contact-optionsnewux">
                    <div class="portal-center-wrapper" [ngClass]="{ 'content-width': noOfContactOptions > 4 }">
                        @if (
                            contactData.csMessage !== null &&
                            contactData.csMessage !== undefined &&
                            !isNullOrUndefined(contactData.csMessage.text) &&
                            !isNullOrUndefined(message)
                        ) {
                            <div class="csMsg" [vnDynamicHtml]="message"></div>
                        }
                        <div
                            class="row justify-content-center cards-row"
                            [ngClass]="{ 'cards-row-twitter': noOfContactOptions > 4 && !phase3, 'd-grid-contact-phase3': phase3 }">
                            @if (enabledContactOptions !== null && enabledContactOptions.length > 0) {
                                @for (contactOption of enabledContactOptions; track i; let i = $index) {
                                    <div
                                        class="card--clickable card card-bg bonus-card card-active-shadow option-card col-sm"
                                        [ngClass]="{
                                            'd-flex justify-content-center': (phase3 && isXsDevice) || (phase3 && isGtXsDevice),
                                            'limit-width': true && isGtXsDevice,
                                        }">
                                        @if (contactOption.key != 'CHAT') {
                                            <div
                                                class="cursorPointer"
                                                [ngClass]="{
                                                    'd-flex align-vertically': phase3,
                                                    'card-body': phase2 && !phase3,
                                                    'mt-3': recommenededOptions.length > 0 && recommenededOptions.indexOf(contactOption.key) > -1,
                                                }"
                                                (click)="goTo(contactOption.key, i)">
                                                @if (recommenededOptions.length > 0 && recommenededOptions.indexOf(contactOption.key) > -1) {
                                                    <ng-container *ngTemplateOutlet="showRecommenededBadge"></ng-container>
                                                }
                                                <div
                                                    class="{{ contactOption.value.messages.class }} option-icon"
                                                    [ngClass]="{
                                                        'text-body': phase3 && !darkModeEnabled,
                                                        'mr-3 ml-4': phase3 || (phase3 && isXsDevice),
                                                        'portrait': phase3 && !darkModeEnabled && isXsDevice,
                                                    }"></div>
                                                <div class="bonus-card-heading-2 option-font" [ngClass]="isXsDevice ? 'align-left' : ''">
                                                    <div [ngClass]="{ 'align-text-in-mobile': phase3 }">
                                                        @if (
                                                            !isNative ||
                                                            (isNative &&
                                                                contactOption.key != 'TWITTER' &&
                                                                contactOption.key != 'FACEBOOK' &&
                                                                contactOption.key != 'INSTAGRAM')
                                                        ) {
                                                            <div>
                                                                <div class="heading">{{ contactOption.value.title }}</div>
                                                            </div>
                                                        }
                                                        <div class="heading">
                                                            @if (isNative && contactOption.key == 'TWITTER') {
                                                                <a target="_blank" [href]="nativeTwitterLink">{{ contactOption.value.title }}</a>
                                                            }
                                                            @if (isNative && contactOption.key == 'FACEBOOK') {
                                                                <a target="_blank" [href]="nativeFaceBookLink">{{ contactOption.value.title }}</a>
                                                            }
                                                            @if (isNative && contactOption.key == 'INSTAGRAM') {
                                                                <a target="_blank" [href]="nativeInstagramLink">{{ contactOption.value.title }}</a>
                                                            }
                                                        </div>
                                                        <div
                                                            class="text-muted-secondary suboption-font bonus-card-heading-1-small contact-touch-pad-0"
                                                            [innerHTML]="contactOption.value.text | trustAsHtml"
                                                            [ngClass]="isXsDevice ? 'align-left' : '  '"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        @if (contactOption.key == 'CHAT') {
                                            <div
                                                class="cursorPointer"
                                                id="chat"
                                                [ngClass]="{ 'd-flex align-vertically': phase3, 'card-body': phase2 && !phase3 }"
                                                (click)="goTo(contactOption.key, i)">
                                                <div
                                                    class="{{ contactOption.value.messages.class }} option-icon"
                                                    [ngClass]="{ 'text-body': phase3 && !darkModeEnabled, 'mr-3 ml-4': phase3 }"></div>
                                                <div
                                                    class="inline"
                                                    [ngClass]="{ 'align-text-in-mobile d-flex flex-column justify-content-center': phase3 }">
                                                    @if (zendeskChatEnabled) {
                                                        <div class="form-element">
                                                            <div class="btn-message-container">
                                                                <pt-pull-chat-button
                                                                    [isContact]="true"
                                                                    [liveChatText]="contactOption.value.title"
                                                                    (click)="liveChatClicked()"></pt-pull-chat-button>
                                                            </div>
                                                        </div>
                                                    }
                                                    <div
                                                        class="text-muted-secondary suboption-font bonus-card-heading-1-small contact-touch-pad-0"
                                                        [innerHTML]="contactOption.value.text | trustAsHtml"
                                                        [ngClass]="isXsDevice ? 'align-left' : '  '"></div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                }
                            }
                            @if (disabledContactOptions !== null && disabledContactOptions.length > 0) {
                                @for (contactOption of disabledContactOptions; track $index) {
                                    <div
                                        class="card--clickable card card-bg bonus-card card-active-shadow option-card col-sm"
                                        [ngClass]="{
                                            'd-flex justify-content-center': (phase3 && isXsDevice) || (phase3 && isGtXsDevice),
                                            'limit-width': true && isGtXsDevice,
                                        }">
                                        <div class="disabled" [ngClass]="{ 'card-body': phase2 && !phase3, 'd-flex align-vertically': phase3 }">
                                            <div
                                                class="{{ contactOption.value.messages.class }} option-icon"
                                                [ngClass]="{
                                                    'text-body': phase3 && !darkModeEnabled,
                                                    'mr-3 ml-4': phase3,
                                                    'portrait': phase3 && !darkModeEnabled && isXsDevice,
                                                }"></div>
                                            <div class="bonus-card-heading-2 option-font" [ngClass]="isXsDevice ? 'align-left' : '  '">
                                                <div [ngClass]="{ 'align-text-in-mobile': phase3 }">
                                                    <div [ngClass]="{ heading: phase3 }">{{ contactOption.value.title }}</div>
                                                    @if (phase3) {
                                                        <div
                                                            class="text-muted-secondary suboption-font bonus-card-heading-1-small contact-touch-pad-0"
                                                            [innerHTML]="contactOption.value.text | trustAsHtml"
                                                            [ngClass]="isXsDevice ? 'align-left' : '  '"></div>
                                                    }
                                                </div>
                                            </div>
                                            @if (phase2 && !phase3) {
                                                <div
                                                    class="text-muted-secondary suboption-font bonus-card-heading-1-small"
                                                    [innerHTML]="contactOption.value.text | trustAsHtml"
                                                    [ngClass]="isXsDevice ? 'align-left' : '  '"></div>
                                            }
                                        </div>
                                    </div>
                                }
                            }
                        </div>
                        @if (
                            (contactData.showDocumentUploadOption && !contactData.isLoadingIndicatorEnabled) ||
                            (contactData.showDocumentUploadOption &&
                                contactData.isLoadingIndicatorEnabled &&
                                contactData.enableHelpAndContactPhase3 &&
                                loadingIndicationDisabled)
                        ) {
                            <div class="border-top" id="docUploadTxt">
                                <span class="theme-upload ic-upload"></span>
                                <a class="a-cur-pr" (click)="goToDocumentUpload()">{{ uploadDocumentContent }}</a>
                                <i class="ui-icon theme-info-i" [floatUi]="popper.content"></i>
                                <vn-popper-content #popper cssClass="tooltip-info"
                                    ><ng-container content>{{ uploadDocumentTooltip }}</ng-container></vn-popper-content
                                >
                            </div>
                        }
                        @if (
                            (contactData.showContactAddress && !contactData.isLoadingIndicatorEnabled) ||
                            (contactData.showContactAddress &&
                                contactData.isLoadingIndicatorEnabled &&
                                contactData.enableHelpAndContactPhase3 &&
                                loadingIndicationDisabled)
                        ) {
                            <div class="d-flex flex-column p-3 border-top" [innerHtml]="contactData.contactInfoText | trustAsHtml"></div>
                        }
                    </div>
                </div>
            }
            @if (this.contactData.helpAndContactUxCleanUpEnabled) {
                <div class="contact-optionsnewux">
                    <div class="portal-center-wrapper" [ngClass]="{ 'content-width': noOfContactOptions > 4 }">
                        @if (!phase3) {
                            <div>
                                <vn-message-panel></vn-message-panel>
                            </div>
                        }
                        <div
                            class="row justify-content-center cards-row"
                            [ngClass]="{
                                'cards-row-v2': v2NavEnabled && isLoggedIn && !newAccountMenuService.isEpcotMenuEnabled() && noOfContactOptions > 3,
                                'cards-row-twitter': noOfContactOptions > 4 && !phase3,
                                'd-grid-contact-phase3': phase3,
                            }">
                            @if (enabledContactOptions !== null && enabledContactOptions.length > 0) {
                                @for (contactOption of enabledContactOptions; track i; let i = $index) {
                                    <div
                                        class="card--clickable card card-bg bonus-card card-active-shadow option-card col-sm"
                                        [ngClass]="{
                                            'd-flex justify-content-center': phase3,
                                            'limit-width': true,
                                        }">
                                        @if (contactOption.key != 'CHAT') {
                                            <div
                                                class="cursorPointer"
                                                [ngClass]="{
                                                    'd-flex align-vertically': phase3,
                                                    'card-body': phase2 && !phase3,
                                                    'mt-3': recommenededOptions.length > 0 && recommenededOptions.indexOf(contactOption.key) > -1,
                                                }"
                                                (click)="goTo(contactOption.key, i)">
                                                @if (recommenededOptions.length > 0 && recommenededOptions.indexOf(contactOption.key) > -1) {
                                                    <ng-container *ngTemplateOutlet="showRecommenededBadge"></ng-container>
                                                }
                                                <div
                                                    class="{{ contactOption.value.messages.class }} option-icon"
                                                    [ngClass]="{
                                                        'text-body': phase3 && !darkModeEnabled,
                                                        'mr-3 ml-4': phase3,
                                                        'portrait': phase3 && !darkModeEnabled && isXsDevice,
                                                    }"></div>
                                                <div class="bonus-card-heading-2 option-font" [ngClass]="isXsDevice ? 'align-left' : '  '">
                                                    <div [ngClass]="{ 'align-text-in-mobile': phase3 }">
                                                        @if (
                                                            !isNative ||
                                                            (isNative &&
                                                                contactOption.key != 'TWITTER' &&
                                                                contactOption.key != 'FACEBOOK' &&
                                                                contactOption.key != 'INSTAGRAM')
                                                        ) {
                                                            <div>
                                                                <div class="heading">{{ contactOption.value.title }}</div>
                                                            </div>
                                                        }
                                                        <div class="heading">
                                                            @if (isNative && contactOption.key == 'TWITTER') {
                                                                <a target="_blank" [href]="nativeTwitterLink">{{ contactOption.value.title }}</a>
                                                            }
                                                            @if (isNative && contactOption.key == 'FACEBOOK') {
                                                                <a target="_blank" [href]="nativeFaceBookLink">{{ contactOption.value.title }}</a>
                                                            }
                                                            @if (isNative && contactOption.key == 'INSTAGRAM') {
                                                                <a target="_blank" [href]="nativeInstagramLink">{{ contactOption.value.title }}</a>
                                                            }
                                                        </div>
                                                        <div
                                                            class="text-muted-secondary suboption-font bonus-card-heading-1-small contact-touch-pad-0"
                                                            [innerHTML]="contactOption.value.text | trustAsHtml"
                                                            [ngClass]="isXsDevice ? 'align-left' : '  '"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        @if (contactOption.key == 'CHAT') {
                                            <div
                                                class="cursorPointer"
                                                id="chat"
                                                [ngClass]="{ 'd-flex align-vertically': phase3, 'card-body': phase2 && !phase3 }"
                                                (click)="goTo(contactOption.key, i)">
                                                <div
                                                    class="{{ contactOption.value.messages.class }} option-icon"
                                                    [ngClass]="{ 'text-body': phase3 && !darkModeEnabled, 'mr-3 ml-4': phase3 }"></div>
                                                <div
                                                    class="inline"
                                                    [ngClass]="{ 'align-text-in-mobile d-flex flex-column justify-content-center': phase3 }">
                                                    @if (zendeskChatEnabled) {
                                                        <div class="form-element">
                                                            <div class="btn-message-container">
                                                                <!-- <span [innerHTML]="ZendeskliveChat"></span> -->
                                                                <pt-pull-chat-button
                                                                    [isContact]="true"
                                                                    [liveChatText]="contactOption.value.title"
                                                                    (click)="liveChatClicked()"></pt-pull-chat-button>
                                                            </div>
                                                        </div>
                                                    }
                                                    <div
                                                        class="text-muted-secondary suboption-font bonus-card-heading-1-small contact-touch-pad-0"
                                                        [innerHTML]="contactOption.value.text | trustAsHtml"
                                                        [ngClass]="isXsDevice ? 'align-left' : '  '"></div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                }
                            }
                            @if (disabledContactOptions !== null && disabledContactOptions.length > 0) {
                                @for (contactOption of disabledContactOptions; track $index) {
                                    <div
                                        class="card--clickable card card-bg bonus-card card-active-shadow option-card col-sm"
                                        [ngClass]="{
                                            'd-flex justify-content-center': (phase3 && isXsDevice) || (phase3 && isGtXsDevice),
                                            'limit-width': true && isGtXsDevice,
                                        }">
                                        <div class="disabled" [ngClass]="{ 'card-body': phase2 && !phase3, 'd-flex align-vertically': phase3 }">
                                            <div
                                                class="{{ contactOption.value.messages.class }} option-icon"
                                                [ngClass]="{
                                                    'text-body': phase3 && !darkModeEnabled,
                                                    'mr-3 ml-4': phase3 || (phase3 && isXsDevice),
                                                    'portrait': phase3 && !darkModeEnabled && isXsDevice,
                                                }"></div>
                                            <div class="bonus-card-heading-2 option-font" [ngClass]="isXsDevice ? 'align-left' : '  '">
                                                <div [ngClass]="{ 'align-text-in-mobile': phase3 }">
                                                    <div [ngClass]="{ heading: phase3 }">{{ contactOption.value.title }}</div>
                                                    @if (phase3) {
                                                        <div
                                                            class="text-muted-secondary suboption-font bonus-card-heading-1-small contact-touch-pad-0"
                                                            [innerHTML]="contactOption.value.text | trustAsHtml"
                                                            [ngClass]="isXsDevice ? 'align-left' : '  '"></div>
                                                    }
                                                </div>
                                            </div>
                                            @if (phase2 && !phase3) {
                                                <div
                                                    class="text-muted-secondary suboption-font bonus-card-heading-1-small"
                                                    [innerHTML]="contactOption.value.text | trustAsHtml"
                                                    [ngClass]="isXsDevice ? 'align-left' : '  '"></div>
                                            }
                                        </div>
                                    </div>
                                }
                            }
                        </div>
                        <div>
                            @if (
                                (contactData.showDocumentUploadOption &&
                                    !contactData.showNewDocumentUploadOption &&
                                    !contactData.isLoadingIndicatorEnabled &&
                                    !isCPCCUser) ||
                                (contactData.showDocumentUploadOption &&
                                    !contactData.showNewDocumentUploadOption &&
                                    contactData.isLoadingIndicatorEnabled &&
                                    contactData.enableHelpAndContactPhase3 &&
                                    loadingIndicationDisabled &&
                                    !isCPCCUser)
                            ) {
                                <div>
                                    <div class="borderline" [ngClass]="{ 'borderline-new': phase2 && phase3 }"></div>
                                    <div id="newdocUploadTxt">
                                        <ul class="newdocUploadTxt-ul newdocUploadTxt-md-ul newdocUploadTxt-ls-ul newdocUploadTxt-ls-li">
                                            <li class="newdocUploadTxt-li newdocUploadTxt-md-li">
                                                <span
                                                    class="theme-upload ic-upload docuploadIcon"
                                                    [ngClass]="{ 'text-body': phase3 && !darkModeEnabled }"></span>
                                                <div class="docUploadContent">
                                                    <div class="to-heading">
                                                        {{ contactOptionsData?.children?.docupload?.title }}
                                                        <div class="docuploadToolTip">
                                                            <i class="theme-info-i" [floatUi]="popper.content"></i>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="btm-heding"
                                                        [innerHTML]="contactOptionsData.children.docupload.messages.UploadDocument"></div>
                                                </div>
                                            </li>
                                            <vn-popper-content #popper cssClass="tooltip-info"
                                                ><ng-container content>{{ uploadDocumentTooltip }}</ng-container>
                                            </vn-popper-content>
                                            <li class="btn-li">
                                                <button
                                                    class="de-emphasize contact-btn"
                                                    ds-button
                                                    kind="secondary"
                                                    type="button"
                                                    variant="outline"
                                                    [innerHTML]="contactOptionsData.children.docupload.messages.UploadDocumentButton"
                                                    (click)="goToDocumentUpload()"></button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            }
                            @if (contactData.showDocumentUploadOption && contactData.showNewDocumentUploadOption && !isCPCCUser) {
                                @if (
                                    !contactData.isLoadingIndicatorEnabled ||
                                    (contactData.isLoadingIndicatorEnabled && contactData.enableHelpAndContactPhase3 && loadingIndicationDisabled)
                                ) {
                                    <div>
                                        <div class="borderline" [ngClass]="{ 'borderline-new': phase2 && phase3 }"></div>
                                        <div id="newdocUploadCard" [ngClass]="{ 'new-doc-uploadCard-mobile': isMobile }">
                                            <div class="card card-bg bonus-card">
                                                <div id="card-header">
                                                    <div
                                                        class="contact-card-header"
                                                        [innerHtml]="contactOptionsData?.children?.docupload?.messages?.NewDocUploadTitle"></div>
                                                </div>
                                                <div
                                                    class="my-3 contact-card-content"
                                                    [innerHtml]="contactOptionsData.children.docupload.messages.NewDocUploadContent"></div>
                                                <div class="button-bottom-margin" [ngClass]="{ 'text-center': !this.isMobile }">
                                                    <button
                                                        class="btn btn-primary"
                                                        type="button"
                                                        [innerHTML]="contactOptionsData.children.docupload.messages.NewDocUploadButton"
                                                        [ngClass]="{ 'w-50': !isMobile, 'w-100': isMobile }"
                                                        (click)="goToDocumentUpload()"></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            }
                            @if (showchathistory) {
                                <div class="portal-center-wrapper content-width chatcard my-5" id="chathistory" (click)="goToHistory()">
                                    <div class="chathistorycard card card--clickable">
                                        <div class="cursorPointer d-flex align-vertically">
                                            <div class="{{ contactData.chatHistoryContent.messages.class }} chatoption mr-3 ml-4"></div>
                                            <div class="chatbonuscard option-font align-left m-2">
                                                <div class="align-text-in-mobile m-3">
                                                    <div class="heading">{{ contactData.chatHistoryContent.title }}</div>
                                                    <div class="text-muted-secondary suboption-font bonus-card-heading-1-small contact-touch-pad-0">
                                                        <p>{{ contactData.chatHistoryContent.messages.ChatHistory }}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            <ng-container *ngId="!isCustomSource">
                                @if (
                                    (contactData.showContactAddress && !contactData.isLoadingIndicatorEnabled) ||
                                    (contactData.showContactAddress &&
                                        contactData.isLoadingIndicatorEnabled &&
                                        contactData.enableHelpAndContactPhase3 &&
                                        loadingIndicationDisabled)
                                ) {
                                    <div
                                        class="borderAddress"
                                        [innerHtml]="contactData.contactInfoText | trustAsHtml"
                                        [ngClass]="{ 'my-5': contactData.showNewDocumentUploadOption }"></div>
                                }
                            </ng-container>
                        </div>
                    </div>
                </div>
            }
        </div>
    </div>
}
<ng-template #showRecommenededBadge>
    @if (recommenededOptions.length > 0) {
        <div class="brat-badge">
            <div class="brat-badge-content d-flex justify-content-center">
                <div class="d-flex align-items-center">
                    <div class="brat-badge-stars d-flex">
                        <span class="theme-rating-star-full"></span>
                    </div>
                </div>
                <div class="brat-badge-most" [vnDynamicHtml]="contactOptionsData.messages.RecommendedBannerText"></div>
            </div>
        </div>
    }
</ng-template>
